import { LitElement } from '@lit'

class NovaVideoPlaylist extends LitElement {
  connectedCallback() {
    super.connectedCallback()
  }

  firstUpdated() {
    this.initializeSlide()

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', () =>
        this.initializeCarousel(),
      )
    }
  }

  initializeSlide() {
    this.slide = this.querySelector('.js-video-playlist-swiper')
    if (!this.slide) return
    this.prev = this.querySelector('.js-video-playlist-prev')
    this.next = this.querySelector('.js-video-playlist-next')
    if (!this.prev || !this.next) return
    // The carousel gap uses CSS variable --nova-space-xs: 10px on mobile
    // and --nova-space-md: 30px on desktop @media (min-width: 768px)
    new Swiper(this.slide, {
      slidesPerView: 1.33,
      grabCursor: true,
      spaceBetween: 10,
      navigation: {
        nextEl: this.next,
        prevEl: this.prev,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.33,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
      mousewheel: {
        forceToAxis: true,
      },
    })

    this.initializeClickEvents()
  }

  initializeClickEvents() {
    this.buttons = this.querySelectorAll('.js-video-playlist-button')
    this.video = this.querySelector('.js-video-playlist-video')
    this.titles = this.querySelectorAll('.js-video-playlist-title')
    if (this.buttons.length <= 0 || !this.video) return
    for (const button of this.buttons) {
      button.addEventListener('click', () => {
        for (const button of this.buttons) {
          button.classList.remove('selected')
        }
        const selectedUrl = button.dataset.videoUrl
        const selectedImage = button.dataset.videoImage
        const selectedTitle = button.dataset.videoTitle
        this.video.setAttribute('src-desktop', selectedUrl)
        this.video.setAttribute('poster-desktop', selectedImage)
        this.video.setAttribute('title', selectedTitle)
        for (const title of this.titles) {
          title.innerText = selectedTitle
        }
        button.classList.add('selected')
      })
    }
  }

  createRenderRoot() {
    return this
  }
}

customElements.define('nova-video-playlist', NovaVideoPlaylist)
